import { resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-78ee62a0")

_pushScopeId("data-v-78ee62a0")
const _hoisted_1 = { class: "answer-container" }
const _hoisted_2 = { class: "content-wrapper" }
const _hoisted_3 = { class: "question-wrapper" }
const _hoisted_4 = { class: "question-title" }
const _hoisted_5 = { class: "up-wrapper" }
const _hoisted_6 = /*#__PURE__*/_createVNode("span", null, "返回首页", -1)
const _hoisted_7 = { class: "up-right-wrapper" }
const _hoisted_8 = /*#__PURE__*/_createVNode("span", null, "答对题数：", -1)
const _hoisted_9 = { class: "middle-wrapper" }
const _hoisted_10 = { class: "middle-info" }
const _hoisted_11 = { class: "middle-info-up" }
const _hoisted_12 = /*#__PURE__*/_createVNode("span", null, "s", -1)
const _hoisted_13 = { class: "middle-info-down" }
const _hoisted_14 = /*#__PURE__*/_createVNode("span", null, "倒计时", -1)
const _hoisted_15 = { class: "down-wrapper" }
const _hoisted_16 = /*#__PURE__*/_createVNode("span", null, "距下一个对手还需答对：", -1)
const _hoisted_17 = /*#__PURE__*/_createVNode("div", { class: "down-progress" }, [
  /*#__PURE__*/_createVNode("div", { class: "down-progress-already" })
], -1)
const _hoisted_18 = { class: "progress-value" }
const _hoisted_19 = { class: "question-content" }
const _hoisted_20 = { class: "question-content-title" }
const _hoisted_21 = {
  key: 1,
  class: "tips-wrapper"
}
const _hoisted_22 = { class: "tips-title" }
const _hoisted_23 = /*#__PURE__*/_createVNode("span", null, "答案解析", -1)
const _hoisted_24 = { class: "correct-answer" }
const _hoisted_25 = /*#__PURE__*/_createVNode("span", null, "正确答案：", -1)
const _hoisted_26 = { class: "tips-content" }
const _hoisted_27 = { class: "pop-award-wrapper" }
const _hoisted_28 = /*#__PURE__*/_createTextVNode("你已成功答对")
const _hoisted_29 = /*#__PURE__*/_createTextVNode("5")
const _hoisted_30 = /*#__PURE__*/_createTextVNode("道题")
const _hoisted_31 = /*#__PURE__*/_createTextVNode("获得")
const _hoisted_32 = /*#__PURE__*/_createTextVNode("1")
const _hoisted_33 = /*#__PURE__*/_createTextVNode("次抽奖机会")
const _hoisted_34 = { class: "pop-award-action" }
const _hoisted_35 = /*#__PURE__*/_createVNode("span", null, "前往抽奖", -1)
const _hoisted_36 = /*#__PURE__*/_createVNode("span", null, "继续刷题", -1)
const _hoisted_37 = /*#__PURE__*/_createVNode("span", null, "狠心退出", -1)
const _hoisted_38 = { class: "pop-award-wrapper" }
const _hoisted_39 = /*#__PURE__*/_createTextVNode("还需答对")
const _hoisted_40 = /*#__PURE__*/_createTextVNode("道题")
const _hoisted_41 = /*#__PURE__*/_createVNode("span", null, "就有机会抱走大奖", -1)
const _hoisted_42 = /*#__PURE__*/_createVNode("span", null, "仍要退出", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Title = _resolveComponent("Title")
  const _component_Action = _resolveComponent("Action")
  const _component_font = _resolveComponent("font")
  const _component_Poper = _resolveComponent("Poper")
  const _component_PopInner = _resolveComponent("PopInner")

  return (_openBlock(), _createBlock(_component_PopInner, null, {
    default: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode(_component_Title, {
          text: `每日答题`,
          subObject: _ctx.subOject
        }, null, 8, ["subObject"]),
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode("div", _hoisted_4, [
              _createVNode("div", _hoisted_5, [
                _createVNode("div", {
                  class: "up-left-wrapper",
                  onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.popLogout && _ctx.popLogout(...args)), ["stop","prevent"]))
                }, [
                  _createVNode("img", {
                    src: `${_ctx.rootUrl}/answer/answer_home.png`
                  }, null, 8, ["src"]),
                  _hoisted_6
                ]),
                _createVNode("div", _hoisted_7, [
                  _hoisted_8,
                  _createVNode("span", null, _toDisplayString(_ctx.questionData.answerRight ? _ctx.questionData.answerRight : 0), 1)
                ])
              ]),
              _createVNode("div", _hoisted_9, [
                _createVNode("img", {
                  src: `${_ctx.rootUrl}/answer/answer_count.png`
                }, null, 8, ["src"]),
                _createVNode("div", _hoisted_10, [
                  _createVNode("div", _hoisted_11, [
                    _createVNode("span", null, _toDisplayString(_ctx.timeCount), 1),
                    _hoisted_12
                  ]),
                  _createVNode("div", _hoisted_13, [
                    _createVNode("img", {
                      src: `${_ctx.rootUrl}/answer/answer_clock.png`
                    }, null, 8, ["src"]),
                    _hoisted_14
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_15, [
                _hoisted_16,
                _hoisted_17,
                _createVNode("span", _hoisted_18, _toDisplayString(_ctx.questionData.answerRight) + "/" + _toDisplayString(_ctx.nextAnswerRight), 1)
              ])
            ]),
            _createVNode("div", _hoisted_19, [
              _createVNode("div", _hoisted_20, [
                _createVNode("p", null, _toDisplayString(_ctx.questionData.title), 1)
              ]),
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.questionData.answer, (i, k) => {
                return (_openBlock(), _createBlock("div", {
                  class: `question-content-answer-item ${
                i.is_right ? 'yes' : ''
              } ${i.is_false ? 'no' : ''}`,
                  key: k,
                  onClick: _withModifiers(($event: any) => (_ctx.doAnswer(i, k)), ["stop","prevent"])
                }, [
                  _createVNode("p", null, _toDisplayString(`${i.key}. ${i.value}`), 1),
                  (i.is_right)
                    ? (_openBlock(), _createBlock("img", {
                        key: 0,
                        src: `${_ctx.rootUrl}/answer/answer_yes.png`
                      }, null, 8, ["src"]))
                    : _createCommentVNode("", true),
                  (i.is_false)
                    ? (_openBlock(), _createBlock("img", {
                        key: 1,
                        src: `${_ctx.rootUrl}/answer/answer_no.png`
                      }, null, 8, ["src"]))
                    : _createCommentVNode("", true)
                ], 10, ["onClick"]))
              }), 128))
            ])
          ]),
          (_ctx.isActionAlready)
            ? (_openBlock(), _createBlock(_component_Action, {
                key: 0,
                class: "action-container",
                text: `继续答题`,
                style: `blue`,
                onAction: _ctx.goOnAnswer
              }, null, 8, ["onAction"]))
            : _createCommentVNode("", true),
          (_ctx.isActionAlready)
            ? (_openBlock(), _createBlock("div", _hoisted_21, [
                _createVNode("div", _hoisted_22, [
                  _createVNode("img", {
                    src: `${_ctx.rootUrl}/answer/answer_tips.png`
                  }, null, 8, ["src"]),
                  _hoisted_23
                ]),
                _createVNode("div", _hoisted_24, [
                  _hoisted_25,
                  _createVNode("span", null, _toDisplayString(_ctx.answerRightKey), 1)
                ]),
                _createVNode("div", _hoisted_26, [
                  _createVNode("p", null, _toDisplayString(_ctx.answerRightDesc), 1)
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      (_ctx.showPopAward)
        ? (_openBlock(), _createBlock(_component_Poper, {
            key: 0,
            onClose: _ctx.closePopAward,
            isYes: true
          }, {
            default: _withId(() => [
              _createVNode("div", _hoisted_27, [
                _createVNode("span", null, [
                  _hoisted_28,
                  _createVNode(_component_font, null, {
                    default: _withId(() => [
                      _hoisted_29
                    ]),
                    _: 1
                  }),
                  _hoisted_30
                ]),
                _createVNode("span", null, [
                  _hoisted_31,
                  _createVNode(_component_font, null, {
                    default: _withId(() => [
                      _hoisted_32
                    ]),
                    _: 1
                  }),
                  _hoisted_33
                ]),
                _createVNode("div", _hoisted_34, [
                  _createVNode("div", {
                    class: "pop-award-action-item",
                    onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.goDraw && _ctx.goDraw(...args)), ["stop","prevent"]))
                  }, [
                    _hoisted_35
                  ]),
                  _createVNode("div", {
                    class: "pop-award-action-item",
                    onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.goOnAnswer && _ctx.goOnAnswer(...args)), ["stop","prevent"]))
                  }, [
                    _hoisted_36
                  ])
                ]),
                _createVNode("div", {
                  class: "pop-award-logout",
                  onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)), ["stop","prevent"]))
                }, [
                  _hoisted_37
                ])
              ])
            ]),
            _: 1
          }, 8, ["onClose"]))
        : _createCommentVNode("", true),
      (_ctx.showPopLogout)
        ? (_openBlock(), _createBlock(_component_Poper, {
            key: 1,
            onClose: _ctx.closePopLogout,
            isNo: true
          }, {
            default: _withId(() => [
              _createVNode("div", _hoisted_38, [
                _createVNode("span", null, [
                  _hoisted_39,
                  _createVNode(_component_font, null, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.getAnswerRightRemain), 1)
                    ]),
                    _: 1
                  }),
                  _hoisted_40
                ]),
                _hoisted_41,
                _createVNode("div", {
                  class: "pop-award-logout",
                  onClick: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)), ["stop","prevent"]))
                }, [
                  _hoisted_42
                ])
              ])
            ]),
            _: 1
          }, 8, ["onClose"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
})